import { map } from "ramda/es"
import React, { Component as C } from "react"
import PropTypes from "prop-types"
import eventlistener from "eventlistener"
import classNames from "classnames"

import withSkinV2 from "@cirrus/legacy/app-common/alt/framework/withSkinV2.jsx"

import styles from "./spread-button.less"
import { MuiIcon } from "@cirrus/ui-kit-ts"

class SpreadButton extends C {
  constructor(props) {
    super(props)
  }

  static defaultProps = {
    list: [],
    alignList: "Left",
    showMenuIcon: false
  }

  static propTypes = {
    list: PropTypes.arrayOf(PropTypes.object),
    alignList: PropTypes.oneOf(["Left", "Right"]),
    listContainerClassName: PropTypes.string,
  }

  state = {
    showList: false,
    showListInProgress: false,
  }

  componentWillUnmount() {
    eventlistener.remove(window, "click", this, false)
  }

  showList(event) {
    if (this.state.showList == true) {
      return
    }

    this.setState({
      showList: true,
      showListInProgress: true,
    })

    this.props.onShow && this.props.onShow()

    this.handleEvent = function () {
      if (this.state.showListInProgress) {
        this.setState({ showListInProgress: false })
        return
      }
      eventlistener.remove(window, "click", this, false)
      this.setState({
        showList: false,
      })
    }

    eventlistener.add(window, "click", this, false)
  }

  getClass() {
    return classNames(styles.button, this.props.className)
  }

  render() {
    const list = map(
      (item) =>
        item ? (
          <li
            key={item.key}
            data-qa={item.key}
            onClick={item.disabled ? (e) => e.stopPropagation() : item.onClick}
            className={classNames({ [styles.itemDisabled]: item.disabled })}>
            <span className={classNames(styles.icon, item.icon)} />
            {item.text}
          </li>
        ) : undefined,
      this.props.list,
    )

    const listClasses = classNames(
      styles.listContainer,
      {
        [styles.alignLeft]: this.props.alignList === "Left",
        [styles.alignRight]: this.props.alignList === "Right",
      },
      this.props.listContainerClassName,
    )

    return (
      <div ref="container" style={{ position: "relative" }}>
        <button
          className={classNames(this.getClass(), this.props.dynamicStyles.classes.button)}
          onClick={this.showList.bind(this)}
          data-qa={this.props.dataQa}
          disabled={this.props.disabled}>
          {this.props.showMenuIcon && <MuiIcon.MoreVert />}
          {this.props.children}
        </button>

        {this.state.showList ? (
          <div className={listClasses}>
            <ul className={styles.list}>{list}</ul>
          </div>
        ) : null}
      </div>
    )
  }
}

const defaultSkinObject = {
  button: {
    color: "",
    borderColor: "",
    backgroundColor: "",
    height: "",
    pm_focus: {
      color: "",
      backgroundColor: "",
      borderColor: "",
    },
    pm_hover: {
      color: "",
      backgroundColor: "",
      borderColor: "",
    },
    pm_active: {
      color: "",
      backgroundColor: "",
      boxShadow: "",
      borderColor: "",
    },
    m_disabled: {
      color: "",
      borderColor: "",
    },
  },
}

export default withSkinV2({
  skinObjectSelector: (skinObject) => skinObject.shareButton || {},
  defaultSkinObject,
})(SpreadButton)
